import { SPATEM } from '_lib/api';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ManageSpatemRsusForm {
  identifier: string;
  /** RSU names, as the SPATEM is sent from them. */
  rsus: string[];
}

const initialState: ManageSpatemRsusForm = {
  identifier: '',
  rsus: [],
};

const manageSpatemRsusFormReducer = createSlice({
  name: 'spatemRsusManage',
  initialState,
  reducers: {
    rsusChanged(state, action: PayloadAction<string[]>) {
      state.rsus = action.payload;
    },
    prefillForm(_state, action: PayloadAction<SPATEM>) {
      const spatem = action.payload;
      return {
        identifier: spatem.identifier,
        rsus: spatem.payload?.rsus ?? [],
      };
    },
    resetForm(_state, _action: PayloadAction<void>) {
      return initialState;
    },
  },
});

export default manageSpatemRsusFormReducer;
